import './Modal.scss'

import close_player from '../../trailerPlayers/modal_yt_player/images/close.png'

export default function Modal({
    btnConfirm,
    btnCancel,
    title,
    btnConfirmText,
    btnCancelText,
}) {
    return (
        <>
            <div className="parentModal" onClick={btnCancel}></div>
            <div className="MainModal">
                <div className="container_modal">
                    <div className="close_modal">
                        <img src={close_player} alt="" onClick={btnCancel} />
                    </div>
                    <div className="title_modal">
                        <h2>{title}</h2>
                    </div>
                    <div className="btn_close_confirm">
                        {btnCancel ?
                            <div className="close_modal_btn card_color" onClick={btnCancel}>
                                <span>{btnCancelText}</span>
                            </div>
                            : null}
                        {btnConfirm ?
                            <div className="confirm_modal_btn card_color" onClick={btnConfirm}>
                                <span>{btnConfirmText}</span>
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </>
    )
}